import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ListItem } from 'material-ui/List';
import Gravatar from 'react-gravatar';

const style = {

    listItem: {
        padding: '2px',
    },
    avatar: {
        borderRadius: '50%',
        marginRight: '16px',
    },
};

const getFlags = (data) => {
    const flags = [];
    if (data.role !== 'delegate') {
        flags.push(<span key="r" className="flag-text">{data.role}</span>)
    }
    return flags.length ? flags : null;
};

const AttendeeListItem = ({ data }) => {

    const infoLink = `/dashboard/user/${data.userId}`;
    return (
        <ListItem
            style={style.listItem}
            leftAvatar={
                <Link to={infoLink}>
                    <Gravatar
                        email={data.email}
                        default='https://cdn.premierit.com/images/icons/contact.png'
                        size={50}
                        style={style.avatar}
                    />
                </Link>
            }
            primaryText={
                <Link to={infoLink} className="primaryText">
                    {`${data.firstName || ''} ${data.lastName || ''}`.trim()}
                </Link>
            }
            secondaryText={
                <Link to={infoLink} className="secondaryText">
                    {getFlags(data)} <em>{data.status}</em>
                </Link>
            }
            secondaryTextLines={2}
        />
    );
};

AttendeeListItem.propTypes = {
    data: PropTypes.shape({
        userId: PropTypes.number.isRequired,
        email: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        status: PropTypes.string,
    })
};

export default AttendeeListItem;
